import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    requestAnimationFrame(() => {
      this.containerTarget.classList.remove("opacity-0", "-translate-y-4")
      this.containerTarget.classList.add("opacity-100", "translate-y-0")
    })
  }

  close() {
    this.containerTarget.classList.remove("opacity-100", "translate-y-0")
    this.containerTarget.classList.add("opacity-0", "-translate-y-4", "pointer-events-none")
  }
}